import { ProjectIntro } from "shared/projects/project-shared/project-intro";
import { ProjectDesc } from "shared/projects/project-shared/project-desc";
import { ProjectOutro } from "shared/projects/project-shared/project-outro";
import { Numbers } from "shared/numbers";
import { SectionData, Section, Image as ImageType } from "shared/types";

import { ProjectImage } from "shared/projects/project-shared/project-image";
import { ProjectMobile } from "shared/projects/project-shared/project-mobile";
import { Visit } from "shared/visit";
import Image from "shared/images";

export const Blast = (props: SectionData) => {
  const projectImageData = {
    image: "blastDesktop" as const,
    text: "",
  };
  const projectMobileData = {
    mobile: "blastMobile" as const,
    tablet: "blastTablet" as const,
  };

  const collana = {
    title: "Proiettili ",
    link: "https://www.ilblast.it/negozio/rivista/",
    image: "blastProiettili" as ImageType,
    desc1:
      "La cultura è un ordigno. Che va costruito, piazzato e fatto esplodere. Oggi assistiamo ad un monopolio dei mezzi di informazione, contro cui una guerra aperta è impossibile e l'unica cosa che possiamo fare è darci alla guerriglia. Come amiamo dire: O SPARIAMO O SPARIAMO! I colpi, prima che fuori, vanno sparati dentro: dentro le nostre teste. Perché, prima di essere un evento reale, ogni conflitto è un evento mentale. Proiettili esiste per questo. Senza munizioni la guerriglia non si fa. Possiamo utilizzare mazze e pietre, ma che senso ha quando la nostra capa è una pistola?",
    desc2:
      "Proiettili - per la guerriglia culturale è l'unica rivista memetica in Italia. Il meme è la lingua di internet, la nostra lingua, quella della nostra generazione, per questo abbiamo deciso di utilizzarlo, è l'arma più potente nelle nostre mani. Scopri i numeri della rivista su <a href='https://www.ilblast.it/rivista' target='_blank' rel='noopener noreferrer'>ilblast.it/rivista</a> e abbonati per avere accesso all'archivio PDF su <a href='https://www.ilblast.it/abbonati' target='_blank' rel='noopener noreferrer'>ilblast.it/abbonati</a>",
  };

  return (
    <div className="project color-black" style={{ backgroundColor: props.bg }}>
      <ProjectIntro {...props} />
      <div className="container full m-auto">
        <ProjectDesc {...props} />
        <ProjectImage {...projectImageData} />
        <ProjectMobile {...projectMobileData} />
        <Numbers data={props.numbers} section={props.section as Section} />
      </div>

      <div className="pangea-extra">
        <div className="container full m-auto">
          <div className="pangea-collana">
            <div className="title heading h-3 font-weight-medium">
              {collana.title}
            </div>
            <div className="image"></div>
            <div className="desc">
              <p>{collana.desc1}</p>
              <p dangerouslySetInnerHTML={{ __html: collana.desc2 }}></p>
            </div>
            <div className="extra">
              <Image name={collana.image} title={collana.title} />
            </div>
          </div>
        </div>
      </div>

      <ProjectOutro {...props} />
    </div>
  );
};
